import { TrashIcon } from 'lucide-react';

import { Button } from 'components/ui/button';

type TotemTrashButtonProps = {
    onClick: () => void;
    disabled?: boolean;
};

export function TotemTrashButton({ onClick, disabled }: TotemTrashButtonProps) {
    return (
        <Button type="button" variant="destructive" size="icon-sm" onClick={onClick} disabled={disabled}>
            <TrashIcon />
        </Button>
    );
}
